export default {
	tongguowomendewangzhan: '通過我們的網站',
	rangninyongyoubuyiyangdetiyan: '讓您擁有不一樣的出行體驗。',
	huanyingguanglin: '歡迎光臨~我們的目標是讓您的旅行夢想成為現實。平臺旨在為您提供價格合理的航班、酒店旅行方案，實現您完美的出行計劃。',
	womenjianxin: '我們堅信通過我們的網站可以讓每個人的出行經歷記憶猶新，並留下美好的回憶，同時我們還在致力於保障您的每次交易的安全可靠，解決您的後顧之憂。',
	wulunzhoumo: '無論周末休閑遊還是長途旅行，我們都將幫您為您提供完美的出行計劃和方案。讓我們一起開始體驗吧！',
	weishenmexuanze: '為什麼選擇我們',
	duozhongluxingxuanze: '多種旅行選擇',
	duozhongluxingxuanzemiaoshu: '我們提供多種旅行服務，以滿足不同的需求偏好和預算。從價格優惠的經濟艙到尊享服務的頭等艙供客戶進行選擇，滿足每一位客戶的出行需求。',
	yonghuyouhaodeyudingliucheng: '用戶友好的預訂流程',
	yonghuyouhaodeyudingliuchengmiaoshu: '我們的預訂流程簡單便捷。只需簡單操作即可篩選出滿足用戶需求的行程和產品並完成預定。',
	gexinghuatuijian: '個性化推薦',
	gexinghuatuijianmiaoshu: '我們根據客戶的旅行偏好和預定歷史，精準為客戶提供量身定製的產品以滿足客戶需求。',
	kekaodekehufuwu: '可靠的客戶服務',
	kekaodekehufuwumiaoshu: '我們提供了可靠的客戶服務，以便於及時、快速的解決客戶在購買產品前和購買後的所遇到的問題。',
	fengfudechanpindiliandejiage: '豐富的產品和低廉的價格',
	fengfudechanpindiliandejiagemiaoshu: '我們的網站匯集全球的產品資源，並提供了豐富的物美價廉的產品，並提供一系列定製化服務以滿足您的旅行喜好。',
	anquankekaodejiaoyi: '安全可靠的交易',
	anquankekaodejiaoyimiaoshu: '我們使用最新技術確保交易的安全可靠。我們致力於保護客戶的個人隱私信息，避免客戶的任何個人信息泄露。'
};
